const ErrorMessage = ({ errors, errorKey }) => {
  return (
    <>
      {errors && errors[errorKey] && (
        <p className="field-error">{errors[errorKey].message}</p>
      )}
    </>
  );
};

export default ErrorMessage;
